import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { SignOut, ClockCounterClockwise, Plus, UsersThree } from "@phosphor-icons/react";

const LOGO = "https://static.prod-images.emergentagent.com/jobs/04052a67-6be6-4ee5-b8f8-93fa74602fd6/images/b0f80c64bf5dde30041c4f458580d7d2cdd5c054a6110b817a85ba9becb588b8.png";

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <header className="sticky top-0 z-40 border-b border-black/30" style={{ backgroundColor: "#0F172A" }}>
      <div className="flex items-center justify-between px-6 h-16">
        <button
          data-testid="logo-home"
          onClick={() => navigate("/")}
          className="flex items-center gap-3"
        >
          <span className="inline-flex items-center">
            <img src={LOGO} alt="FMiQ" className="h-9 w-auto" />
          </span>
          <span className="hidden sm:flex items-center gap-2 pl-3 border-l border-white/15">
            <span className="font-heading font-bold text-sm text-white tracking-tight">Dataset Delta</span>
            <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/45">Comparison</span>
          </span>
        </button>

        <div className="flex items-center gap-1">
          {location.pathname !== "/" && (
            <Button
              variant="ghost"
              size="sm"
              data-testid="nav-new-comparison"
              onClick={() => navigate("/")}
              className="gap-1.5 text-white hover:bg-white/10 hover:text-white"
            >
              <Plus size={16} /> New
            </Button>
          )}
          <Button
            variant="ghost"
            size="sm"
            data-testid="nav-history"
            onClick={() => navigate("/history")}
            className="gap-1.5 text-white hover:bg-white/10 hover:text-white"
          >
            <ClockCounterClockwise size={16} /> History
          </Button>
          {user?.role === "admin" && (
            <Button
              variant="ghost"
              size="sm"
              data-testid="nav-admin"
              onClick={() => navigate("/admin")}
              className="gap-1.5 text-white hover:bg-white/10 hover:text-white"
            >
              <UsersThree size={16} /> Admin
            </Button>
          )}
          <div className="hidden sm:block text-xs text-white/55 font-mono px-3">
            {user?.email}
          </div>
          <Button
            variant="ghost"
            size="sm"
            data-testid="logout-button"
            onClick={logout}
            className="gap-1.5 text-white/80 hover:bg-white/10 hover:text-white"
          >
            <SignOut size={16} /> Exit
          </Button>
        </div>
      </div>
    </header>
  );
}
